import { __exports as y } from "../../../../_virtual/common.es.js";
var o;
function m() {
  return o ? y : (o = 1, function(a) {
    var l = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
    function h(n, r) {
      return Object.prototype.hasOwnProperty.call(n, r);
    }
    a.assign = function(n) {
      for (var r = Array.prototype.slice.call(arguments, 1); r.length; ) {
        var t = r.shift();
        if (t) {
          if (typeof t != "object")
            throw new TypeError(t + "must be non-object");
          for (var u in t)
            h(t, u) && (n[u] = t[u]);
        }
      }
      return n;
    }, a.shrinkBuf = function(n, r) {
      return n.length === r ? n : n.subarray ? n.subarray(0, r) : (n.length = r, n);
    };
    var g = {
      arraySet: function(n, r, t, u, f) {
        if (r.subarray && n.subarray) {
          n.set(r.subarray(t, t + u), f);
          return;
        }
        for (var e = 0; e < u; e++)
          n[f + e] = r[t + e];
      },
      // Join array of chunks to single array.
      flattenChunks: function(n) {
        var r, t, u, f, e, i;
        for (u = 0, r = 0, t = n.length; r < t; r++)
          u += n[r].length;
        for (i = new Uint8Array(u), f = 0, r = 0, t = n.length; r < t; r++)
          e = n[r], i.set(e, f), f += e.length;
        return i;
      }
    }, A = {
      arraySet: function(n, r, t, u, f) {
        for (var e = 0; e < u; e++)
          n[f + e] = r[t + e];
      },
      // Join array of chunks to single array.
      flattenChunks: function(n) {
        return [].concat.apply([], n);
      }
    };
    a.setTyped = function(n) {
      n ? (a.Buf8 = Uint8Array, a.Buf16 = Uint16Array, a.Buf32 = Int32Array, a.assign(a, g)) : (a.Buf8 = Array, a.Buf16 = Array, a.Buf32 = Array, a.assign(a, A));
    }, a.setTyped(l);
  }(y), y);
}
export {
  m as __require
};
//# sourceMappingURL=common.es.js.map
